import request from '@/network/http'

export function login(data) {
    return request({
        url: 'Users/Users/quickLogin',
        method: 'post',
        data
    })
}

export function logout() {
    return request({
        url: 'Users/Users/logout',
        method: 'post',
    })
}

export function updatePassword(data) {
  return request({
    url: 'Users/Users/updatePassword',
    method: 'post',
    data
  })
}





// WEBPACK FOOTER //
// ./src/apis/login.js